module.exports = __webpack_public_path__ + "static/media/risk.bf5da505.jpg";